import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTableDataSource } from '@angular/material';
import { FormBuilder, FormArray } from '@angular/forms';
import { GetInactiveReplacedUsers, MoveTaskToNextState } from '../store/tasks.actions'
import { Subject } from 'rxjs';
import { NotificationModalComponent } from 'src/app/features/common-components/notification-modal/notification-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CommentDialogue } from '../comment-dialogue/comment-dialog.component';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

export const BASE_URL = environment.host;



@Component({
    selector: 'task-reopen-dialog',
    templateUrl: './task-reopen-dialog.component.html',
    styleUrls: ['./task-reopen-dialog.component.scss']
})
export class TaskReopenDialogComponent implements OnInit, OnDestroy {

    stopper$: Subject<any> = new Subject();
    replacedUsers: any
    taskId: string
    dummy: any
    displayedColumns = ['oldMember', 'replacedWith']
    dataSource: MatTableDataSource<any>;



    constructor(
        private matDialogRef: MatDialogRef<TaskReopenDialogComponent>,
        private dialog: MatDialog,
        private store: Store<AppState>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private http: HttpClient
    ) { }

    ngOnInit() {
        this.data.taskId
        if (this.data.taskId != undefined) {
            this.store.dispatch(new GetInactiveReplacedUsers(this.data.taskId))
            this.store.select(state => state.tasks.replacedUsers).subscribe(users => {
                if (users.inactiveUserExists) {
                    this.replacedUsers = users.suggestions.map(user => {
                        return {
                            oldUser: user.userId.firstName + ' ' + user.userId.middleName + ' ' + user.userId.lastName,
                            oldUserId: user.userId._id,
                            replacedUser: user.suggestions[0].firstName + ' ' + user.suggestions[0].middleName + ' ' + user.suggestions[0].lastName,
                            replacedUserId: user.suggestions[0]._id
                        }
                    })
                }
                this.dataSource = new MatTableDataSource(this.replacedUsers || []);
            })
        }
    }

    cancel() {
        this.matDialogRef.close('');
    }

    submit() {
        this.cancel()
        const dialogRef = this.dialog.open(CommentDialogue, {
            width: '700px',
            hasBackdrop: true,
            panelClass: 'cmp-modal',
        });

        dialogRef.afterClosed().subscribe((response) => {
            if (response) {
                // if (Object.keys(this.ngxPermissionService.getPermissions()).includes('document-comments')) {
                let payload = response;
                // }

                let userPayload = { updates: [] }
                userPayload.updates = this.replacedUsers.map(user => {
                    return { oldUser: user.oldUserId, newUser: user.replacedUserId }
                })

                this.http.post(`${BASE_URL}/task/` + this.data.taskId + `/update-replaced-users`, userPayload)
                this.store.dispatch(new MoveTaskToNextState(this.data.taskId, this.data.action, { comment: payload }));
            }
        })
    }

    ngOnDestroy() {
        this.stopper$.next();
        this.stopper$.complete();
    }

}
